import { apiClient } from './apiClient';

export const authService = {
    // Using getUserByCpf as login for now based on existing logic
    login: async (cpf) => {
        try {
            const response = await apiClient.get(`/cedentes/cpf/${encodeURIComponent(cpf)}`);
            return response.data;
        } catch (error) {
            if (error.response?.status === 400) {
                const detail = error.response.data.detail;
                throw new Error(typeof detail === 'string' ? detail : "Dados de acesso inválidos.");
            }
            if (error.response?.status === 404) {
                throw new Error("CPF não encontrado em nossa base de dados.");
            }
            if (error.response?.status === 403) {
                throw new Error(error.response.data.detail || "Conta inativa. Por favor, entre em contato com o suporte.");
            }
            throw error;
        }
    }
};
